import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.jsx'
import './i18n.js'
import './index.css' 
import "primereact/resources/themes/vela-orange/theme.css";
import 'primeicons/primeicons.css';
createRoot(document.getElementById('root')).render(

    <App />,
)
